import { z } from 'zod'

export const useAssociateValidator = () => {
  const loginSchema = z.object({
    email: z.string().email('Email inválido'),
  })

  type LoginForm = z.infer<typeof loginSchema>
  type LoginErrors = Partial<Record<keyof LoginForm, string>>

  const createForm = (): LoginForm => ({
    email: '',
  })

  const createEmptyErrors = (): LoginErrors => ({
    email: '',
  })

  const validateForm = (form: LoginForm): { isValid: boolean; errors: LoginErrors } => {
    const errors = createEmptyErrors()

    try {
      loginSchema.parse(form)
      return { isValid: true, errors }
    } catch (error) {
      if (error instanceof z.ZodError) {
        error.errors.forEach((e) => {
          const field = e.path[0] as keyof LoginForm
          errors[field] = e.message
        })
      }
      return { isValid: false, errors }
    }
  }

  const resetForm = (form: LoginForm): void => {
    form.email = ''
  }

  const resetErrors = (errors: LoginErrors, field?: keyof LoginErrors): void => {
    if (field) {
      errors[field] = ''
    } else {
      Object.keys(errors).forEach((key) => {
        errors[key as keyof LoginErrors] = ''
      })
    }
  }

  return {
    loginSchema,
    createForm,
    createEmptyErrors,
    validateForm,
    resetForm,
    resetErrors,
  }
}

export type LoginForm = z.infer<ReturnType<typeof useAssociateValidator>['loginSchema']>
export type LoginErrors = Partial<Record<keyof LoginForm, string>>
